import React from "react";
import { connect } from "react-redux";
import KIT from "../../Descargable/Kit de Apoyo E4.zip";
import { dataLayerTag } from "../functions";

class KitSeguimientoPlanMovilidad extends React.PureComponent {
  render() {
    return (
      <div>
          <div className="row">
            <div className="col-sm-9 text-left">
              <div className="PM-cuadro-3">
              <h5><strong>Descarga el kit de difusión con material digital.</strong></h5>
              </div>
            </div>
            <div className="col-sm-3 btn-material">
              <button
                className="btn PM-dx-button-plan PM-dx-button-plan-100 PM-button-light"
                onClick={() => {
                  window.open(KIT,'_blank');

                  const {tareasPlanesMovilidad} = this.props;
                  const nombreAcciones=[];
                  for(let i; i<tareasPlanesMovilidad.length; i++){
                    nombreAcciones.push(tareasPlanesMovilidad[i].descripcion);
                  }

                  // gtd -> descarga de kit etapa 4
                  dataLayerTag({
                    'event': 'etapa_4_descarga_kit',
                    'etapa': '4',
                    'acciones_checkeadas': nombreAcciones,
                  });
                }}
              >Descargar kit</button>
            </div>
          </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  idplanMovilidad: state.planMovilidad.idplanMovilidad,
  tareasPlanesMovilidad: state.planMovilidad.tareasPlanesMovilidad,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(KitSeguimientoPlanMovilidad);
